import apiFetch from '../apiFetch'

export default function (token, processingAgencyId) {
  return apiFetch({ endPoint: `ProcessingAgencyManagers/${processingAgencyId}`, method: 'GET', token: token })
}
